import { CONTRACT_TYPE } from "../../../contract/customer-contract/lib/constants/contract_type"

const defaults = {
  isSortable: true,
  isEditable: true,
  thStyle: 'width: 25%',
}
const contractFields = [
  {
    ...defaults,
    key: 'number',
    label: 'Nomor Kontrak',
  },
  {
    ...defaults,
    key: 'status.name',
    label: 'Status',
  },
  {
    ...defaults,
    key: 'total_vehicle',
    label: 'Jumlah Kendaraan',
    formatter: (value) => value ? value : 0,
  },
  {
    ...defaults,
    label: 'Jenis Kontrak',
    key: 'contract_type',
    formatter: (value) => CONTRACT_TYPE?.[value]?.name ?? '-',
  },
  {
    ...defaults,
    label: 'Tanggal Berakhir',
    key: 'expired_date',
  }
]

export default contractFields
